<template>
  <div>
    <div class="pos intro-y grid grid-cols-12 gap-5 mt-5">
      <!-- BEGIN: Ticket -->
      <div class="col-span-12">
        <div class="intro-y pr-1">
          <div v-if="register.exchangeType == 1" class="box p-2">
            <div class="grid grid-cols-12">
              <div class="intro-y col-span-6">
                <button class="button w-full mr-1 bg-theme-1 text-white">
                  <a
                    data-toggle="tab"
                    class="flex-1 py-2 rounded-md text-center active"
                    @click="handleExchangeType(1)"
                  >
                    <p class="sm:flex justify-center items-center font-medium">
                      외화
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        class="feather feather-chevron-right breadcrumb__icon"
                      >
                        <polyline points="9 18 15 12 9 6"></polyline>
                      </svg>
                      원화
                    </p>
                  </a>
                </button>
              </div>
              <div class="intro-y col-span-6">
                <button
                  class="button w-full ml-1 mr-1 text-gray-700 dark:bg-dark-5 dark:text-gray-300"
                >
                  <a
                    data-toggle="tab"
                    class="flex-1 py-2 rounded-md text-center"
                    @click="handleExchangeType(2)"
                  >
                    <p class="sm:flex justify-center items-center font-medium">
                      원화
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        class="feather feather-chevron-right breadcrumb__icon"
                      >
                        <polyline points="9 18 15 12 9 6"></polyline>
                      </svg>
                      외화
                    </p>
                  </a>
                </button>
              </div>
            </div>
          </div>
          <div v-else class="box p-2">
            <div class="grid grid-cols-12">
              <div class="intro-y col-span-6">
                <button
                  class="button w-full mr-1 text-gray-700 dark:bg-dark-5 dark:text-gray-300"
                >
                  <a
                    data-toggle="tab"
                    class="flex-1 py-2 rounded-md text-center active"
                    @click="handleExchangeType(1)"
                  >
                    <p class="sm:flex justify-center items-center font-medium">
                      외화
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        class="feather feather-chevron-right breadcrumb__icon"
                      >
                        <polyline points="9 18 15 12 9 6"></polyline>
                      </svg>
                      원화
                    </p>
                  </a>
                </button>
              </div>
              <div class="intro-y col-span-6">
                <button class="button w-full mr-1 bg-theme-6 text-white">
                  <a
                    data-toggle="tab"
                    class="flex-1 py-2 rounded-md text-center"
                    @click="handleExchangeType(2)"
                  >
                    <p class="sm:flex justify-center items-center font-medium">
                      원화
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        class="feather feather-chevron-right breadcrumb__icon"
                      >
                        <polyline points="9 18 15 12 9 6"></polyline>
                      </svg>
                      외화
                    </p>
                  </a>
                </button>
              </div>
            </div>
          </div>
        </div>
        <div class="tab-content">
          <div id="ticket" class="tab-content__pane active">
            <div class="intro-y box py-10 sm:py-10 mt-5">
              <div class="px-5 sm:px-20 border-gray-200 dark:border-dark-5">
                <div
                  v-if="register.exchangeType == 1"
                  class="grid grid-cols-12 gap-10 mt-1"
                >
                  <div
                    v-for="(moneyCategory, index) in $store.state.main
                      .moneyCategories"
                    :key="index"
                    class="col-span-12 sm:col-span-3 xxl:col-span-2"
                  >
                    <div
                      v-if="selectedMoneyCategoryCode == moneyCategory.code"
                      class="box bg-theme-1 dark:bg-theme-1 py-2 cursor-pointer zoom-in text-center"
                      @click="
                        selectMoneyItem(moneyCategory.code, moneyCategory.unit)
                      "
                    >
                      <img
                        alt="Midone Tailwind HTML Admin Template"
                        class="w-12 mx-auto"
                        :src="
                          require(`@/assets/images/flags/${moneyCategory.img}`)
                        "
                      />
                      <div class="text-white mt-2">
                        {{ moneyCategory.country }}
                      </div>
                    </div>
                    <div
                      v-else
                      class="box py-2 cursor-pointer zoom-in text-center"
                      @click="
                        selectMoneyItem(moneyCategory.code, moneyCategory.unit)
                      "
                    >
                      <img
                        alt="Midone Tailwind HTML Admin Template"
                        class="w-12 mx-auto"
                        :src="
                          require(`@/assets/images/flags/${moneyCategory.img}`)
                        "
                      />
                      <div class="text-black dark:text-white mt-2">
                        {{ moneyCategory.country }}
                      </div>
                    </div>
                  </div>
                </div>
                <div v-else class="grid grid-cols-12 gap-10 mt-1">
                  <div
                    v-for="(moneyCategory, index) in $store.state.main
                      .moneyCategories"
                    :key="index"
                    class="col-span-12 sm:col-span-3 xxl:col-span-2"
                  >
                    <div
                      v-if="selectedMoneyCategoryCode == moneyCategory.code"
                      class="box bg-theme-6 dark:bg-theme-6 py-2 cursor-pointer zoom-in text-center"
                      @click="
                        selectMoneyItem(moneyCategory.code, moneyCategory.unit)
                      "
                    >
                      <img
                        alt="Midone Tailwind HTML Admin Template"
                        class="w-12 mx-auto"
                        :src="
                          require(`@/assets/images/flags/${moneyCategory.img}`)
                        "
                      />
                      <div class="text-white mt-2">
                        {{ moneyCategory.country }}
                      </div>
                    </div>
                    <div
                      v-else
                      class="box py-2 cursor-pointer zoom-in text-center"
                      @click="
                        selectMoneyItem(moneyCategory.code, moneyCategory.unit)
                      "
                    >
                      <img
                        alt="Midone Tailwind HTML Admin Template"
                        class="w-12 mx-auto"
                        :src="
                          require(`@/assets/images/flags/${moneyCategory.img}`)
                        "
                      />
                      <div class="text-black dark:text-white mt-2">
                        {{ moneyCategory.country }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div
                id="register_userData"
                class="px-5 sm:px-20 mt-5 pt-5 border-t border-gray-200 dark:border-dark-5"
              >
                <div class="grid grid-cols-12 gap-4 row-gap-5">
                  <div class="intro-x col-span-12 lg:col-span-4">
                    <div class="flex flex-col sm:flex-row items-center">
                      <label class="w-full sm:w-32 sm:text-right sm:mr-5"
                        >성명</label
                      >
                      <input
                        id="userNameInput"
                        v-model="register.userName"
                        autocomplete="off"
                        class="input w-full border mt-2 flex-1"
                        placeholder="성명"
                        @input="onChangeInputUserName($event)"
                      />
                    </div>
                  </div>
                  <div class="intro-x col-span-12 lg:col-span-1">
                    <div class="flex flex-col sm:flex-row">
                      <label
                        v-if="historyCount != 0"
                        class="w-full border mt-4 sm:w-32 sm:text-left sm:mr-5"
                      >
                        {{ historyCount }}
                      </label>
                    </div>
                  </div>
                  <div class="intro-y col-span-12 lg:col-span-4">
                    <div class="flex flex-col sm:flex-row items-center">
                      <label class="w-full sm:w-32 sm:text-right sm:mr-5"
                        >국적</label
                      >
                      <div class="intro-x relative w-full flex-1">
                        <input
                          id="inputNationality"
                          v-model="register.nationalityName"
                          type="text"
                          autocomplete="off"
                          class="input w-full border mt-2 flex-1"
                          placeholder="국적"
                          @focus="showSearchDropdown"
                          @blur="hideSearchDropdown"
                          @input="onChangeInputCountry($event)"
                          @keyup.enter="enterSelectCountry()"
                        />
                        <div
                          class="dropdown-box w-full"
                          :class="{ show: searchDropdown }"
                        >
                          <div
                            class="dropdown-box__content box dark:bg-dark-1 p-2 overflow-y-auto h-32"
                          >
                            <a
                              v-for="(country, index) in countries"
                              :key="index"
                              class="flex items-center block p-2 transition duration-300 ease-in-out bg-white dark:bg-dark-1 hover:bg-gray-200 dark:hover:bg-dark-2 rounded-md"
                              @click="onSelectCountry(country)"
                              >{{ country.name }}</a
                            >
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="intro-y col-span-12 lg:col-span-4">
                    <div class="flex flex-col sm:flex-row items-center">
                      <label class="w-full sm:w-32 sm:text-right sm:mr-5">
                        여권번호
                      </label>
                      <input
                        id="inputPassportId"
                        v-model="register.passportNo"
                        autocomplete="off"
                        class="input w-full border mt-2 flex-1"
                        placeholder="여권번호"
                        @keyup.enter="onFocusForeignCurrency"
                      />
                    </div>
                  </div>
                  <div class="intro-x col-span-12 lg:col-span-1"></div>
                  <div class="intro-y col-span-12 lg:col-span-4">
                    <div class="flex flex-col sm:flex-row items-center">
                      <label class="w-full sm:w-32 sm:text-right sm:mr-5">
                        주민등록번호
                      </label>
                      <input
                        id="inputregisternceID"
                        v-model="register.residenceNo"
                        autocomplete="off"
                        class="input w-full border mt-2 flex-1"
                        placeholder="주민등록번호"
                        @keyup.enter="onFocusForeignCurrency"
                      />
                    </div>
                  </div>
                  <div class="intro-y col-span-12 lg:col-span-4">
                    <div class="flex flex-col sm:flex-row items-center">
                      <label class="w-full sm:w-32 sm:text-right sm:mr-5">
                        기타
                      </label>
                      <input
                        id="inputExtra"
                        v-model="register.others"
                        autocomplete="off"
                        class="input w-full border mt-2 flex-1"
                        placeholder="기타"
                        @keyup.enter="onFocusForeignCurrency"
                      />
                    </div>
                  </div>
                  <div class="intro-x col-span-12 lg:col-span-1"></div>
                  <div class="intro-y col-span-12 lg:col-span-4">
                    <div class="flex flex-col sm:flex-row items-center">
                      <label class="w-full sm:w-32 sm:text-right sm:mr-5">
                        외국인등록번호
                      </label>
                      <input
                        id="inputForeignResidenceId"
                        v-model="register.foreignResidenceNo"
                        autocomplete="off"
                        class="input w-full border mt-2 flex-1"
                        placeholder="외국인등록번호"
                        @keyup.enter="onFocusForeignCurrency"
                      />
                    </div>
                  </div>
                  <div class="intro-y col-span-12 lg:col-span-2">
                    <div class="px-5 pt-5 border-gray-200 dark:border-dark-5">
                      <div class="grid grid-cols-12 gap-4 row-gap-5">
                        <div
                          class="intro-y sm:col-span-12 md:col-span-12 lg:col-span-10 xl:col-span-10 xxl:col-span-10 flex items-center justify-end"
                        >
                          <button
                            v-if="register.exchangeType == 1"
                            class="button w-full block bg-theme-1 text-white ml-2"
                            @click="clickScanBtn()"
                          >
                            스캔
                          </button>
                          <button
                            v-else
                            class="button w-full block bg-theme-6 text-white ml-2"
                            @click="clickScanBtn()"
                          >
                            스캔
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div
                v-for="(registerItem, index) in registers"
                :key="index"
                ref="registerItems"
                class="px-5 sm:px-20 mt-5 pt-5 border-t border-gray-200 dark:border-dark-5"
              >
                <div class="grid grid-cols-12 gap-4 row-gap-5">
                  <div
                    class="intro-y col-span-12 lg:col-span-4"
                    @click="onClickRegisterItem(index)"
                  >
                    <div class="flex flex-col sm:flex-row items-center">
                      <label
                        class="w-full sm:w-32 sm:text-right sm:mr-5 text-lg"
                      >
                        외화금액({{ registerItem.moneyCategoryCode }})
                      </label>
                      <input
                        :id="`inputForeignCurrency${index}`"
                        v-model="registerItem.foreignCurrencyStr"
                        placeholder="외화금액"
                        autocomplete="off"
                        class="input w-full border mt-2 flex-1 text-lg"
                        @keyup="onKeyUpForeignCurrency($event, index)"
                        @input="onChangeInputForeignCurrency($event, index)"
                        @keyup.enter="onForeignEnterKeyPressed(index)"
                      />
                    </div>
                  </div>
                  <div class="intro-x col-span-12 lg:col-span-1"></div>
                  <div
                    class="intro-y col-span-12 lg:col-span-4"
                    @click="onClickRegisterItem(index)"
                  >
                    <div class="flex flex-col sm:flex-row items-center">
                      <label
                        class="w-full sm:w-32 sm:text-right sm:mr-5 text-lg"
                      >
                        환율
                      </label>
                      <input
                        v-if="register.exchangeType == 1"
                        :id="`inputRate${index}`"
                        v-model="registerItem.inRate"
                        :readonly="!registerItem.isDisableRate"
                        class="input w-full border mt-2 flex-1 text-lg"
                        placeholder="환율"
                        autocomplete="off"
                        @click="enableManualRate(index)"
                        @input="onChangeInputForeignCurrency($event, index)"
                        @keyup.enter="confirmRegister()"
                      />
                      <input
                        v-if="register.exchangeType == 2"
                        :id="`inputRate${index}`"
                        v-model="registerItem.outRate"
                        :readonly="!registerItem.isDisableRate"
                        class="input w-full border mt-2 flex-1 text-lg"
                        placeholder="환율"
                        autocomplete="off"
                        @click="enableManualRate(index)"
                        @input="onChangeInputForeignCurrency($event, index)"
                        @keyup.enter="confirmRegister()"
                      />
                    </div>
                  </div>
                  <div class="intro-y col-span-12 lg:col-span-3">
                    <div class="border-gray-200 dark:border-dark-5 mt-3 mb-3">
                      <el-checkbox
                        v-model="registerItem.isDisableRate"
                        class="button text-gray-700 ml-1 button w-24 dark:text-white"
                        @change="clickConstantBtn(index)"
                      >
                        수동설정
                      </el-checkbox>
                      <button
                        v-if="index == 0"
                        class="button bg-theme-4 text-white ml-2 button w-24"
                        @click="showConstantRateModal"
                      >
                        환율설정
                      </button>
                    </div>
                  </div>
                  <div
                    class="intro-y col-span-12 lg:col-span-4"
                    @click="onClickRegisterItem(index)"
                  >
                    <div class="flex flex-col sm:flex-row items-center">
                      <label
                        class="w-full sm:w-32 sm:text-right sm:mr-5 text-lg"
                      >
                        원화금액(KRW)
                      </label>
                      <div class="w-full flex-1">
                        <currency-input
                          v-model="registerItem.localCurrency"
                          currency="KRW"
                          autocomplete="off"
                          class="input w-full border text-lg"
                          @input="onChangeInputLocalCurrency($event)"
                          @keyup.enter="onForeignEnterKeyPressed(index)"
                        />
                        <div v-if="registerItem.cutAmount != 0" class="m-2">
                          {{
                            $h.filterCurrency(registerItem.localOrignCurrency)
                          }}
                        </div>
                      </div>
                    </div>
                    <div v-if="register.exchangeType == 2" class="intro-y col-span-12 lg:col-span-14 mt-8">
                    <div class="grid grid-cols-12 gap-4">
                      <div class="col-span-12 lg:col-span-7 flex flex-col sm:flex-row items-center">
                        <label class="w-full sm:w-32 sm:text-right sm:mr-12 text-lg">받은 금액</label>
                        <input
                          type="text"
                          v-model="registerItem.receivedAmountStr"
                          class="input w-40 border text-lg"
                          placeholder="받은 원화 금액"
                          @input="onInputReceivedAmount($event, index)"
                        />
                      </div>
                      
                      <div class="col-span-12 lg:col-span-5 flex flex-col sm:flex-row items-center">
                        <label class="w-full sm:w-32 sm:text-right sm:mr-5 text-lg">거스름돈</label>
                        <div class="input w-full border text-lg bg-gray-100 flex items-center px-2 min-h-[40px]">
                          <span v-if="registerItem.localCurrency > 0 && registerItem.receivedAmount > 0" class="font-bold text-theme-0">
                            {{ $h.filterCurrency(registerItem.receivedAmount - registerItem.localCurrency) }}
                          </span>
                          <span v-else class="text-gray-500">0</span>
                        </div>
                      </div>
                    </div>
                  </div>
                  </div>
                  <div class="intro-y col-span-12 lg:col-span-1"></div>
                  <div
                    class="intro-y col-span-12 lg:col-span-7"
                    @click="onClickRegisterItem(index)"
                    @keyup.enter="confirmRegister()"
                  >
                    <div class="flex flex-col sm:flex-row items-center">
                      <label
                        v-if="register.exchangeType == 1"
                        class="w-full sm:w-32 sm:text-right sm:mr-5"
                      >
                        절상
                      </label>
                      <label
                        v-if="register.exchangeType == 2"
                        class="w-full sm:w-32 sm:text-right sm:mr-5"
                      >
                        절하
                      </label>
                      <div class="w-full flex-1">
                        <div class="flex flex-col xl:flex-row justify-start">
                          <el-checkbox
                            v-model="registerItem.optionValue1"
                            @input="onClickOption(1, index)"
                          >
                            10
                          </el-checkbox>
                          <el-checkbox
                            v-model="registerItem.optionValue2"
                            @input="onClickOption(2, index)"
                          >
                            50
                          </el-checkbox>
                          <el-checkbox
                            v-model="registerItem.optionValue3"
                            @input="onClickOption(3, index)"
                          >
                            100
                          </el-checkbox>
                          <el-checkbox
                            v-model="registerItem.optionValue4"
                            @input="onClickOption(4, index)"
                          >
                            500
                          </el-checkbox>
                          <el-checkbox
                            v-model="registerItem.optionValue5"
                            @input="onClickOption(5, index)"
                          >
                            1000
                          </el-checkbox>
                          <el-checkbox
                            v-model="registerItem.optionValue6"
                            @input="onClickOption(6, index)"
                          >
                            5000
                          </el-checkbox>
                          <el-checkbox
                            v-model="registerItem.optionValue7"
                            @input="onClickOption(7, index)"
                          >
                            10000
                          </el-checkbox>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    class="intro-y pr-1 col-span-12 lg:col-span-4 m-3"
                    style="display: flex; justify-content: flex-start"
                  >
                    <div
                      v-if="
                        registers.length >= 2 && index == registers.length - 1
                      "
                      class="col-span-12 lg:col-span-12"
                    >
                      <div class="w-full ml-1 mr-1 text-gray-100 ">
                        <label
                          class="w-full sm:w-32 sm:text-right sm:mr-5 text-lg"
                        >
                          합 계 (KRW)
                        </label>
                        <label
                          class="w-full sm:w-32 sm:text-left sm:ml-5 sm:mr-5 text-lg"
                        >
                          ￦ {{ printData.totalPrice.toLocaleString() }}
                        </label>
                      </div>
                    </div>
                  </div>
                  <div
                    class="intro-y lg:col-span-8"
                    style="display: flex; justify-content: flex-end"
                  >
                    <div class="px-5 pt-5 border-gray-200 dark:border-dark-5">
                      <div
                        v-if="register.exchangeType == 1"
                        class="flex items-center justify-start"
                      >
                        <button
                          v-if="index == 0"
                          class="button block bg-theme-7 text-white ml-2 w-24"
                          @click="showShortKeyModal"
                        >
                          단축키
                        </button>
                        <button
                          v-if="index == 0"
                          class="button block bg-theme-9 text-white ml-2 w-24"
                          @click="addRegister()"
                        >
                          추가
                        </button>
                        <button
                          v-if="index == 0"
                          class="button block bg-theme-1 text-white ml-2 w-40"
                          @click="confirmRegister()"
                        >
                          영수증출력
                        </button>
                        <button
                          v-else
                          class="button justify-center block bg-theme-6 text-white ml-2 button w-24"
                          @click="deleteRegister(index)"
                        >
                          삭제
                        </button>
                      </div>
                      <div v-else class="flex items-center justify-start">
                        <button
                          v-if="index == 0"
                          class="button block bg-theme-7 text-white ml-2 w-24"
                          @click="showShortKeyModal"
                        >
                          단축키
                        </button>
                        <button
                          v-if="index == 0"
                          class="button block bg-theme-9 text-white ml-2 w-24"
                          @click="addRegister()"
                        >
                          추가
                        </button>
                        <button
                          v-if="index == 0"
                          class="button block bg-theme-6 text-white ml-2 w-40"
                          @click="confirmRegister()"
                        >
                          영수증출력
                        </button>
                        <button
                          v-else
                          class="button justify-center block bg-theme-6 text-white ml-2 button w-24"
                          @click="deleteRegister(index)"
                        >
                          삭제
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- END: Ticket -->
    </div>
    <div id="confirm-modal-preview" class="modal">
      <div class="modal__content">
        <div class="p-5 text-center">
          <CheckCircleIcon class="w-16 h-16 text-theme-9 mx-auto mt-3" />
          <div class="text-3xl mt-5">
            출력 하시겠습니까?
          </div>
          <div
            class="box bg-theme-5 justify-center my-10 mx-auto"
            style="width: 12rem;"
          >
            <div id="printArea" class="preview p-5">
              <div class="flex flex-col sm:flex-row items-center">
                <label class="w-full sm:w-40 sm:text-right text-lg">
                  {{ printData.printedDate }}
                </label>
              </div>
              <br class="printhide" />
              <div v-for="(printItem, index) in printDatas" :key="index">
                <div class="flex flex-col sm:flex-row items-center">
                  <label class="w-full sm:w-40 sm:text-right text-lg font-bold">
                    {{ printItem.foreignCurrency }}
                  </label>
                </div>
                <div class="flex flex-col sm:flex-row items-center">
                  <label class="w-full sm:w-40 sm:text-right text-lg">
                    {{ printItem.rate }}
                  </label>
                </div>
                <div class="flex flex-col sm:flex-row items-center">
                  <label class="w-full sm:w-40 sm:text-right text-lg">
                    {{ printItem.result }}
                  </label>
                </div>
                <br v-if="registers.length != 1" class="printhide" />
              </div>
              <div
                v-if="registers.length != 1"
                class="flex flex-col sm:flex-row items-center"
              >
                <div class="w-full sm:w-40 sm:text-right">
                  ===============
                </div>
              </div>
              <div
                v-if="registers.length != 1"
                class="flex flex-col sm:flex-row items-center"
              >
                <div class="w-full sm:w-40 sm:text-right text-lg">
                  T {{ $h.filterCurrency(printData.totalPrice) }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="px-5 pb-8 text-center">
          <button
            type="button"
            class="button w-24 border text-gray-700 dark:border-dark-5 dark:text-gray-300 mr-1"
            @click="handleCancel"
          >
            취소
          </button>
          <button
            type="button"
            class="button w-24 bg-theme-1 text-white"
            @click="handleRegister"
          >
            확인
          </button>
        </div>
      </div>
    </div>
    <div id="scan-confirmation-modal" class="modal">
      <div class="modal__content">
        <div class="p-5 text-center">
          <xCircleIcon class="w-16 h-16 text-theme-6 mx-auto mt-3" />
          <div class="text-3xl mt-5">스캔연결이 실패하였습니다.</div>
          <div class="text-gray-600 mt-2">
            스캔프로그램이 정확히 기동되었는지 확인해주세요.
          </div>
        </div>
        <div class="px-5 pb-8 text-center">
          <button
            type="button"
            data-dismiss="modal"
            class="button w-24 border text-gray-700 mr-1"
          >
            취소
          </button>
          <a
            href="/download/exchangeSocketApp.rar"
            data-dismiss="modal"
            class="button bg-theme-6 w-24 inline-block mr-1 mb-2 bg-gray-200 text-white"
            >다운로드</a
          >
        </div>
        <!-- BEGIN: Update History Confirmation Modal -->
        <div id="shortKey_modal" class="modal">
          <div
            class="modal__content p-5"
            style="margin-top: 15vh; width: 50vw;"
          >
            <div
              class="flex items-center px-5 py-5 sm:py-3 border-b border-gray-200 dark:border-dark-5 relative"
              style="display: flex; justify-content: center;"
            >
              <div class="text-center">
                <h2 class="text-3xl text-base mr-auto">단축키설정</h2>
              </div>
              <a
                data-dismiss="modal"
                href="javascript:;"
                class="absolute right-0 top-0 mt-3 mr-3"
              >
                <xIcon class="w-8 h-8 text-gray-500" />
              </a>
            </div>
            <div id="bordered-table" class="p-5">
              <div class="preview">
                <div class="overflow-x-auto">
                  <table class="table">
                    <thead>
                      <th
                        class="border border-b-2 dark:border-dark-5 whitespace-no-wrap text-center"
                      >
                        지정키
                      </th>
                      <th
                        class="border border-b-2 dark:border-dark-5 whitespace-no-wrap text-center"
                      >
                        입력값
                      </th>
                      <th
                        class="border border-b-2 dark:border-dark-5 whitespace-no-wrap text-center"
                      >
                        편집
                      </th>
                    </thead>
                    <tbody>
                      <tr v-for="item in shortKeyResigers" :key="item.id">
                        <td class="border dark:border-dark-5 text-center">
                          {{ item.key }}
                        </td>
                        <td class="border dark:border-dark-5 text-center">
                          {{ item.value }}
                        </td>
                        <td class="border dark:border-dark-5 text-center">
                          <div class="flex justify-center items-center">
                            <a
                              class="flex items-center text-theme-6"
                              href="javascript:;"
                              @click="clickDeleteShortKeyBtn(item.id)"
                            >
                              <Trash2Icon class="w-4 h-4 mr-1" /> 삭제
                            </a>
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td
                          class="border border-b-2 dark:border-dark-5 whitespace-no-wrap text-center"
                        >
                          <div class="w-full flex-1">
                            <input
                              :id="`shortKeyRegister_key`"
                              v-model="tempShortKeyResigers.key"
                              class="input w-full border mt-2 flex-1 text-lg"
                              placeholder="지정키"
                              autocomplete="off"
                              @keyup="onChangeInputShortKey($event)"
                            />
                          </div>
                        </td>
                        <td
                          class="border border-b-2 dark:border-dark-5 whitespace-no-wrap text-center"
                        >
                          <div class="w-full flex-1">
                            <input
                              v-model="tempShortKeyResigers.value"
                              class="input w-full border mt-2 flex-1 text-lg"
                              placeholder="입력값"
                              autocomplete="off"
                              @keyup.enter="addShortKeyResiger"
                            />
                          </div>
                        </td>
                        <td
                          class="border border-b-2 dark:border-dark-5 whitespace-no-wrap text-center"
                        >
                          <div
                            class="px-5 text-center lg:col-span-12"
                            style="display: flex; justify-content: center"
                          >
                            <button
                              type="button"
                              class="button w-15 bg-theme-7 text-white dark:border-dark-1 dark:text-gray-300 mr-1"
                              @click="addShortKeyResiger"
                            >
                              추가
                            </button>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            <div class="px-5 p-8 text-center">
              <button
                type="button"
                class="button w-20 bg-theme-6 text-white dark:border-dark-1 dark:text-gray-300 mr-5"
                @click="hideShortKeyModal"
              >
                취소
              </button>
              <button
                type="button"
                class="button w-20 bg-theme-1 text-white dark:border-dark-1 dark:text-gray-300 mr-5"
                @click="updateConfirmShortKeyResiger"
              >
                저장
              </button>
            </div>
          </div>
        </div>
        <!-- END: Update History Modal -->
        <!-- BEGIN: Update History Confirmation Modal -->
        <div id="constant_CurrencyRate_modal" class="modal">
          <div class="modal__content modal__content--lg p-4" style="margin-top: 3vh;">
            <div
              class="flex items-center px-5 py-5 sm:py-3 border-b border-gray-200 dark:border-dark-5 relative"
              style="display: flex; justify-content: center;"
            >
              <div class="text-center">
                <h2 class="text-3xl text-base mr-auto">환율설정</h2>
              </div>
              <a
                data-dismiss="modal"
                href="javascript:;"
                class="absolute right-0 top-0 mt-3 mr-3"
              >
                <xIcon class="w-8 h-8 text-gray-500" />
              </a>
            </div>
            <div id="bordered-table" class="p-5">
              <div class="preview">
                <div class="overflow-x-auto">
                  <table class="table" >
                    <thead>
                      <th
                        class="border border-b-2 dark:border-dark-5 whitespace-no-wrap text-center"
                      ></th>
                      <th
                        class="border border-b-2 dark:border-dark-5 whitespace-no-wrap text-center"
                      >
                        매입
                      </th>
                      <th
                        class="border border-b-2 dark:border-dark-5 whitespace-no-wrap text-center"
                      >
                        매도
                      </th>
                      <th 
                      class="border border-b-2 dark:border-dark-5 whitespace-no-wrap text-center"
                      >
                        우대환율
                      </th>
                      <th
                        class="border border-b-2 dark:border-dark-5 whitespace-no-wrap text-center"
                      >
                        환율 경고 범위(%)
                      </th>                      
                    </thead>
                    <tbody>
                      <tr
                        v-for="item in tempConstantRateMoenyCategories"
                        :key="item.id"
                      >
                        <td
                          class="border dark:border-dark-5 text-center"
                          style="width: 15%;"
                        >
                          {{ item.code }}
                        </td>
                        <td
                          class="border dark:border-dark-5 text-center"
                          style="padding: 0%; width: 20%;"
                        >
                          <input
                            v-model="item.inRate"
                            class="input w-full flex-1 text-sm"
                            placeholder="0"
                            autocomplete="off"
                            @input="onChangeInputRate($event, item.id)"
                            @keyup.enter="ConfirmConstantRate"
                          />
                        </td>
                        <td
                          class="border dark:border-dark-5 text-center"
                          style="padding: 0%; width: 20%;"
                        >
                          <input
                            v-model="item.outRate"
                            class="input w-full flex-1 text-sm"
                            placeholder="0"
                            autocomplete="off"
                            @input="onChangeInputRate($event, item.id)"
                            @keyup.enter="ConfirmConstantRate"
                          />
                        </td>
                        <td 
                          class="border dark:border-dark-5 text-center" 
                          style="padding: 0%; width: 20%;"
                        >
                          <input
                            v-model="item.specialRate" 
                            class="input w-full flex-1 text-sm"
                            placeholder="0"
                            autocomplete="off"
                            @input="onChangeInputRate($event, item.id)"
                            @keyup.enter="ConfirmConstantRate"
                          />
                        </td>
                        <td
                          class="border dark:border-dark-5 text-center"
                          style="padding: 0%; width: 20%;"
                        >
                          <input
                            v-model="item.minRateThreshold"
                            class="input w-full flex-1 text-sm"
                            placeholder="0"
                            autocomplete="off"
                            :disabled="item.code === 'OTH'"
                            :class="{ 'bg-gray-100': item.code === 'OTH' }"
                            @input="onChangeInputRate($event, item.id)"
                            @keyup.enter="ConfirmConstantRate"
                          />
                        </td>                        
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            <div class="px-5 p-1 text-center">
              <button
                type="button"
                class="button w-20 bg-theme-6 text-white dark:border-dark-1 dark:text-gray-300 mx-2"
                @click="hideShortKeyBtn"
              >
                취소
              </button>
              <button
                type="button"
                class="button w-20 bg-theme-1 text-white dark:border-dark-1 dark:text-gray-300 mx-2"
                @click="ConfirmConstantRate"
              >
                저장
              </button>
            </div>
          </div>
        </div>
        <!-- END: Update History Modal -->
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import Toastify from "toastify-js";
import printJS from "print-js";
import moment from "moment";
import jQuery from "jquery";
import cash from "cash-dom";
import io from "socket.io-client";

var wsUri = "ws://127.0.0.1:7717/";

export default {
  data() {
    return {
      scanLoadingFLag: false,
      isProcessing: false,
      modalFlag: false,
      countries: [],
      tmpCountries: [],
      searchDropdown: false,
      selectedMoneyCategoryCode: "",
      selectedMoneyCategoryUnit: "",
      selectedIndex: 0,
      registers: [
        {
          inRate: "",
          outRate: "",
          foreignCurrency: 0,
          foreignCurrencyStr: "",
          localCurrency: "",
          localOrignCurrency: 0,
          cutAmount: 0,
          moneyCategoryCode: "USD",
          moneyCategoryUnit: "$ ",
          receivedAmount: 0,
          receivedAmountStr: "",
          optionValue1: false,
          optionValue2: false,
          optionValue3: false,
          optionValue4: false,
          optionValue5: false,
          optionValue6: false,
          optionValue7: false,
          isDisableRate: false
        }
      ],
      register: {
        userName: "",
        nationality: "",
        nationalityName: "",
        passportNo: "",
        residenceNo: "",
        foreignResidenceNo: "",
        others: "",
        exchangeType: 1
      },
      printDatas: [
        {
          foreignCurrency: "",
          rate: "",
          result: ""
        }
      ],
      printData: {
        printedDate: "",
        totalPrice: ""
      },
      historyCount: 0,
      shortKeyResigers: [],
      tempShortKeyResigers: {
        id: 0,
        key: "",
        value: ""
      },
      ConstantRateMoneyCategories: [],
      tempConstantRateMoenyCategories: [],
      socket: null,
      serverMessage: "",
      isRateUpdating: false,
      websocket: null,
      isWebsocketNeed: true
    };
  },
  async mounted() {
    // console.log("mounted");
    await this.tokenLogin();
    await this.getMoneyCategories();
    this.getCountries();
    await this.getShortKeysResiger();
    await this.getConstantRateMoney();
    this.connectSocket();
    //window.addEventListener("keyup", ev => {
    //// console.log(ev.key);
    //});
    this.setAutoFocus(0);
    if (this.$h.isEmpty(this.websocket)) {
      this.testWebSocket();
    }
    this.$store.dispatch("main/setIsShowBtn", false);
  },
  beforeDestroy() {
    // console.log("unmounted!");
    window.removeEventListener("keyup", this.functionEnter);
    window.removeEventListener("keydown", this.functionArrowKeydown);
    this.isWebsocketNeed = false;
    this.disconnectSocket();
    if (this.websocket) {
      this.websocket.close(); // WebSocket 연결 해제
      this.websocket = null; // WebSocket 객체 초기화
    }
  },
  async created() {
    // console.log("created");
    window.addEventListener("keyup", this.functionEnter);
    window.addEventListener("keydown", this.functionArrowKeydown); // 화살표 통화 이동 (입력칸 포커스 중에도)
    //(function() {
    //  window.addEventListener("click", function(e) {
    //    // console.log(e);
    //  });
    //})();
  },
  methods: {
    connectSocket() {
      if (this.socket && this.socket.connected) {
        return; // 이미 연결되어 있으면 재연결 방지
      }
      // 서버 주소 (백엔드 Socket.IO 서버가 실행 중인 주소 및 포트)
      this.socket = io(String(this.$api().socketUrl), {
        reconnection: true, // 자동 재연결 허용
        reconnectionAttempts: Infinity, // 무한 재연결
        reconnectionDelay: 5000, // 첫 재시도 간격 (2초)
        reconnectionDelayMax: 10000, // 최대 재시도 간격 (10초)
        timeout: 20000 // 연결 타임아웃 (20초)
      });

      this.socket.on("connect", () => {
        //console.log("Vue 클라이언트: 서버에 연결됨");
        let clientData = {
          id: this.$store.state.auth.user.id,
          agencyId: this.$store.state.auth.user.agencyId,
          isAdmin: this.$store.state.auth.user.isAdmin
        };
        let sendMessage = JSON.stringify(clientData);
        this.socket.emit("client_id", sendMessage);
      });

      this.socket.on("disconnect", () => {
        //console.log("Vue 클라이언트: 서버 연결 끊김");
      });
      this.socket.on("reconnect", () => {
        if (this.isWebsocketNeed == false) {
          return;
        }
        // console.log(`서버에 재연결됨 (${attempt}번째 시도 후)`);
        // 연결 성공 시 다시 client_id 전송
        let clientData = {
          id: this.$store.state.auth.user.id,
          agencyId: this.$store.state.auth.user.agencyId,
          isAdmin: this.$store.state.auth.user.isAdmin
        };
        this.socket.emit("client_id", JSON.stringify(clientData));
      });
      // 서버에서 'broadcast' 이벤트가 오면 receivedData 배열에 데이터를 추가
      this.socket.on("broadcast", () => {
        if (this.isWebsocketNeed == false) {
          return;
        }
        // console.log("Vue 클라이언트: 메시지받음");
        this.handleRateUpdate();
      });

      // (선택 사항) 서버에서 'server_message' 이벤트를 받으면 serverMessage 업데이트
      this.socket.on("server_message", message => {
        this.serverMessage = message;
      });
    },
    disconnectSocket() {
      if (this.socket) {
        this.socket.disconnect();
        this.socket = null;
      }
    },
    async handleRateUpdate() {
      if (this.isRateUpdating) {
        return; // 이미 업데이트 중이면 중복 호출 방지
      }

      this.isRateUpdating = true;
      let data = {
        agencyId: this.$store.state.auth.user.agencyId,
        token: this.$h.assign(this.$store.state.auth.user.token)
      };

      await axios.post(this.$api().getConstantRate, data).then(res => {
        if (res.status === 200) {
          const newRates = JSON.parse(res.data.data.constRate);
          // console.log("newRates ; ", newRates);
          const oldRates = this.ConstantRateMoneyCategories;
          // console.log("oldRates ; ", oldRates);
          const tempMoneyCategories = this.$store.state.main.moneyCategories;

          const updatedRates = [];

          for (let i = 0; i < newRates.length; i++) {
            const newRate = newRates[i];
            const oldRate = oldRates.find(r => r.code === newRate.code);
            if (
              oldRate &&
              (oldRate.inRate !== newRate.inRate ||
                oldRate.outRate !== newRate.outRate ||
                oldRate.minRateThreshold !== newRate.minRateThreshold ||
              oldRate.specialRate !== newRate.specialRate)
            ) {
              // console.log("newRate ; ", newRate.inRate);
              // console.log("oldRate ; ", oldRate.inRate);
              const moneyCategory = tempMoneyCategories.find(
                c => c.code === newRate.code
              );
              // console.log(moneyCategory);
              if (moneyCategory) {
                Toastify({
                  text: `${moneyCategory.name} (${moneyCategory.code}) 환율이 업데이트 되었습니다.`,
                  duration: 5000,
                  newWindow: true,
                  close: true,
                  gravity: "top",
                  position: "right",
                  backgroundColor: "#0e2c88",
                  stopOnFocus: true
                }).showToast();
              }
            }

            // 새로 배열에 넣을 값 구성
            updatedRates.push({
              id: i,
              code: newRate.code,
              inRate: newRate.inRate,
              outRate: newRate.outRate,
              minRateThreshold: newRate.minRateThreshold || 0, // 추가
              specialRate: newRate.specialRate || 0
            });
          }

          // 전체 갱신 (Vue 반응성 유지)
          this.ConstantRateMoneyCategories = updatedRates;
          this.sortConstantRateMoneyCategories(); // 정렬 유지
        }
      });

      this.updateRegistersCurrency(); // registers에 새로운 환율 적용
      this.isRateUpdating = false; // 업데이트 완료
    },
    onClickRegisterItem(index) {
      this.selectedIndex = index;
    },
    onFocusForeignCurrency() {
      setTimeout(() => {
        jQuery(`#inputForeignCurrency${0}`).focus();
      }, 10);
    },
    onInputReceivedAmount(event, index) {
      // 숫자 외 문자 제거
      const val = event.target.value.replace(/[^0-9]/g, "");
      const numericValue = parseInt(val);

      if (!isNaN(numericValue)) {
        this.registers[index].receivedAmount = numericValue;
        this.registers[index].receivedAmountStr = numericValue.toLocaleString();
      } else {
        this.registers[index].receivedAmount = 0;
        this.registers[index].receivedAmountStr = "";
      }
      
      // 거스름돈 계산은 Template 내에서 (receivedAmount - localCurrency)로 자동 처리됨
    },
    addRegister() {
      this.selectedIndex = this.registers.length;
      this.registers.push({
        inRate: "",
        outRate: "",
        foreignCurrency: "",
        localCurrency: "",
        localOrignCurrency: 0,
        cutAmount: 0,
        moneyCategoryCode: this.selectedMoneyCategoryCode,
        moneyCategoryUnit: this.selectedMoneyCategoryUnit + " ",
        optionValue1: false,
        optionValue2: false,
        optionValue3: false,
        optionValue4: false,
        optionValue5: false,
        optionValue6: false,
        optionValue7: false,
        isDisableRate: false // Ensure this property is initialized
      });
      this.printDatas.push({
        printedDate: "",
        foreignCurrency: "",
        rate: "",
        result: ""
      });
      this.setAutoFocus(this.registers.length - 1);
    },
    removeRegister() {
      if (this.registers.length > 1) {
        this.registers.pop();
        this.printDatas.pop();
        this.selectedIndex = this.registers.length - 1;
        this.setAutoFocus(this.registers.length - 1);
      }
    },
    deleteRegister(index) {
      if (this.registers.length > 1) {
        this.registers.splice(index, 1);
        this.printDatas.splice(index, 1);
        this.selectedIndex = this.registers.length - 1;
        this.setAutoFocus(this.registers.length - 1);
      }
    },
    // 화살표 = 통화(국가) 이동. keydown 에서 처리해 기본동작(커서이동/스크롤)을 확실히 차단하고,
    // 외화금액/환율 입력칸에 포커스가 있어도 동작한다. (이름/국적/여권 등 텍스트 칸은 커서 이동 보존을 위해 제외)
    functionArrowKeydown(ev) {
      if (!["ArrowUp", "ArrowDown", "ArrowLeft", "ArrowRight"].includes(ev.key)) return;
      const el = document.activeElement;
      const tag = el ? el.tagName : "";
      if (tag === "INPUT" || tag === "TEXTAREA") {
        const id = el.id || "";
        const isTradeInput =
          id.indexOf("inputForeignCurrency") === 0 || id.indexOf("inputRate") === 0;
        if (!isTradeInput) return; // 그 외 입력칸에서는 기본 동작 유지
      }
      ev.preventDefault();
      this.handleArrowKey(ev.key);
    },
    async functionEnter(ev) {
      // console.log("event caued : ", ev);
      const activeEl = document.activeElement;
      const isInputFocused = activeEl.tagName === "INPUT" || activeEl.tagName === "TEXTAREA";

      if (["ArrowUp", "ArrowDown", "ArrowLeft", "ArrowRight"].includes(ev.key)) {
        return; // 화살표는 keydown(functionArrowKeydown)에서 처리 — keyup 중복 이동 방지
      }

      if (ev.key == "Escape") {
        this.modalFlag = false;
        cash("#confirm-modal-preview").modal("hide");
        cash("#constant_CurrencyRate_modal").modal("hide");
        cash("#shortKey_modal").modal("hide");
      } else if (ev.key == "+") {
        this.addRegister();
      } else if (ev.key == "-") {
        let fieldId = ev.target.id;
        // console.log("fieldID : ", fieldId);
        if (
          fieldId === "userNameInput" ||
          fieldId === "inputNationality" ||
          fieldId === "inputPassportId" ||
          fieldId === "inputregisternceID" ||
          fieldId === "inputExtra" ||
          fieldId === "inputForeignResidenceId"
        ) {
          return;
        }
        this.removeRegister();
      } else if (event.key == "`" || event.key == "*") {
        this.scanPassport();
      }
      window.removeEventListener("beforeunload", this.functionEnter);
    },
    async tokenLogin() {
      let data = {
        token: window.localStorage.getItem("exchange_token")
      };
      let resultData = {};
      await axios.post(this.$api().tokenLogin, data).then(res => {
        resultData = res.data;
      });
      if (this.$h.isEmpty(resultData)) {
        this.$store.commit("auth/SET_USER", null);
        this.$store.commit("auth/SET_ISLOGINED", false);
        this.$router.replace("/");
      } else if (resultData.error) {
        this.$store.commit("auth/SET_USER", null);
        this.$store.commit("auth/SET_ISLOGINED", false);
        this.$router.replace("/");
      } else {
        this.$store.commit("auth/SET_USER", resultData.userData);
        this.$store.commit("auth/SET_ISLOGINED", true);
        window.localStorage.setItem(
          "exchange_token",
          resultData.userData.token
        );
      }
    },
    initOptions(type, index) {
      //console.log("56");
      this.registers[index].cutAmount = 0;
      type == 1
        ? (this.registers[index].optionValue1 = true)
        : (this.registers[index].optionValue1 = false);
      type == 2
        ? (this.registers[index].optionValue2 = true)
        : (this.registers[index].optionValue2 = false);
      type == 3
        ? (this.registers[index].optionValue3 = true)
        : (this.registers[index].optionValue3 = false);
      type == 4
        ? (this.registers[index].optionValue4 = true)
        : (this.registers[index].optionValue4 = false);
      type == 5
        ? (this.registers[index].optionValue5 = true)
        : (this.registers[index].optionValue5 = false);
      type == 6
        ? (this.registers[index].optionValue6 = true)
        : (this.registers[index].optionValue6 = false);
      type == 7
        ? (this.registers[index].optionValue7 = true)
        : (this.registers[index].optionValue7 = false);
    },
    testWebSocket() {
      if (this.websocket && this.websocket.readyState === WebSocket.OPEN) {
        return; // 이미 연결된 상태라면 새 연결을 생성하지 않음
      }
      // WebSocket이 닫혀 있거나 유효하지 않은 경우 새 연결 생성
      if (
        !this.websocket ||
        this.websocket.readyState === WebSocket.CLOSED ||
        this.websocket.readyState === WebSocket.CLOSING
      ) {
        this.websocket = new WebSocket(wsUri);
        var thisObject = this;

        this.websocket.onopen = function() {
          //console.log("WebSocket 연결 성공");
        };

        this.websocket.onmessage = function(evt) {
          thisObject.onMessage(evt);
        };

        // this.websocket.onerror = function(evt) {
        //   //console.error("WebSocket 오류:", evt);
        // };

        this.websocket.onclose = function() {
          if (this.isWebsocketNeed == true) {
            // console.log("WebSocket 연결 종료, 재연결 시도 중...");
            setTimeout(() => {
              thisObject.testWebSocket(); // 재연결 시도
            }, 5000); // 5초 후 재연결 시도
          }
        };
      }
    },
    scanPassport() {
      if (this.isWebsocketNeed == false) {
        // console.log("websocket 아님");
        return;
      }
      if (this.scanLoadingFLag) {
        return; // 이미 실행 중이면 중복 실행 방지
      }
      this.register.userName = "";
      this.register.passportNo = "";
      this.register.residenceNo = "";
      this.register.nationality = "";
      this.register.nationalityName = "";
      this.scanLoadingFLag = true;

      if (this.websocket.readyState !== WebSocket.OPEN) {
        //console.log("123");
        this.testWebSocket();
      }
      var thisObject = this;
      //console.log("456");
      setTimeout(async function() {
        var jsonData = {
          type: 1,
          message: "hello"
        };
        thisObject.doSend(jsonData);
        setTimeout(async function() {
          if (thisObject.scanLoadingFLag == true) {
            Toastify({
              text: "새로고침하시고 다시 스캔해주세요.",
              duration: 3000,
              newWindow: true,
              close: true,
              gravity: "bottom",
              position: "left",
              backgroundColor: "#e53231",
              stopOnFocus: true
            }).showToast();
            thisObject.scanLoadingFLag = false;
            thisObject.hideLoading();
          }
        }, 5000);
      }, 500);
    },
    onError() {
      this.scanLoadingFLag = false;
      this.hideLoading();
      //alert(JSON.stringify(err));
    },
    onMessage(evt) {
      if (this.isWebsocketNeed == false) {
        return;
      }
      if (!this.scanLoadingFLag) {
        return;
      }
      this.scanLoadingFLag = false;
      this.hideLoading();
      let res = JSON.parse(evt.data);
      // console.log(res);
      if (res.status == 1) {
        let csvRecord = res.record;
        this.register.userName = csvRecord.name;
        this.register.passportNo = csvRecord.passportNo;
        this.register.nationality = csvRecord.nationality;
        this.register.residenceNo = csvRecord.residenceNo;
        for (let i = 0; i < this.tmpCountries.length; i++) {
          if (this.tmpCountries[i].code == this.register.nationality) {
            this.register.nationalityName = this.tmpCountries[i].name;
          }
        }

        this.handleUserHistoryCount(
          this.register.userName,
          this.register.nationality,
          this.register.passportNo,
          this.register.residenceNo
        );
        this.setAutoFocus(0);
        Toastify({
          text: "스캔성공되었습니다.",
          duration: 3000,
          newWindow: true,
          close: true,
          gravity: "bottom",
          position: "left",
          backgroundColor: "#0e2c88",
          stopOnFocus: true
        }).showToast();
      } else {
        Toastify({
          text: res.message,
          duration: 3000,
          newWindow: true,
          close: true,
          gravity: "bottom",
          position: "left",
          backgroundColor: "#e53231",
          stopOnFocus: true
        }).showToast();
      }
    },
    setAutoFocus(index) {
      setTimeout(() => {
        var el = jQuery("#inputForeignCurrency" + index + ":text").get(0);
        var elemLen = el.value.length;
        el.selectionStart = elemLen;
        el.selectionEnd = elemLen;
        el.focus();
      }, 30);
    },
    doSend(message) {
      if (this.websocket.readyState === WebSocket.OPEN) {
        this.scanLoadingFLag = true;
        this.showLoading();
        this.websocket.send(JSON.stringify(message));
      } else {
        this.register.userName = "";
        this.register.passportNo = "";
        this.register.residenceNo = "";
        this.register.nationality = "";
        this.register.nationalityName = "";
        cash("#scan-confirmation-modal").modal("show");
      }
    },
    clickScanBtn() {
      this.scanPassport();
    },
    onSelectCountry(country) {
      this.register.nationalityName = country.name;
      this.register.nationality = country.code;
    },
    enterSelectCountry() {
      const countryName = this.register.nationalityName;
      this.countries = this.$h.findItemsFromArray(
        this.tmpCountries,
        countryName
      );
      if (this.countries.length > 0) {
        this.register.nationalityName = this.countries[0].name;
        this.register.nationality = this.countries[0].code;
      } else {
        this.register.nationality = "";
      }
    },
    onChangeInputUserName() {
      const userName = jQuery("#userNameInput").val();
      const nationality = jQuery("#inputNationality").val();
      const passportNo = jQuery("#inputPassportId").val();
      const registerenceId = jQuery("#inputregisternceID").val();
      // console.log("userName : ", userName);
      this.handleUserHistoryCount(
        userName,
        nationality,
        passportNo,
        registerenceId
      );
    },
    onChangeInputCountry() {
      const countryName = jQuery("#inputNationality").val();
      if (this.$h.isEmpty(countryName)) {
        this.register.nationalityName = "";
        this.register.nationality = "";
        return;
      }
      this.countries = this.$h.findItemsFromArray(
        this.tmpCountries,
        countryName
      );
      if (this.countries.length > 0) {
        this.register.nationality = this.countries[0].code;
      } else {
        this.register.nationality = "";
      }
    },
    showSearchDropdown() {
      this.searchDropdown = true;
    },
    hideSearchDropdown() {
      this.searchDropdown = false;
    },
    async getMoneyCategories() {
      let data = {
        token: this.$h.assign(this.$store.state.auth.user.token)
      };
      await axios.post(this.$api().getMoneyCategories, data).then(res => {
        let resultData = this.$h.assign(res.data);
        this.$store.dispatch("main/setMoneyCategories", resultData.data);
        if (this.$store.state.main.moneyCategories.length > 0) {
          this.selectMoneyItem(
            this.$store.state.main.moneyCategories[0].code,
            this.$store.state.main.moneyCategories[0].unit
          );
        }
      });
    },
    async getConstantRate() {
      let data = {
        agencyId: this.$store.state.auth.user.agencyId,
        token: this.$h.assign(this.$store.state.auth.user.token)
      };
      // console.log("getConstantRate called : ", data);
      this.ConstantRateMoneyCategories = [];
      await axios.post(this.$api().getConstantRate, data).then(res => {
        if (res.status == 200) {
          let resultData = JSON.parse(res.data.data.constRate);
          for (var i = 0; i < resultData.length; i++) {
            this.ConstantRateMoneyCategories.push({
              id: i,
              code: resultData[i].code,
              inRate: resultData[i].inRate,
              outRate: resultData[i].outRate,
              minRateThreshold: resultData[i].minRateThreshold,
              specialRate: resultData[i].specialRate
            });
          }
          this.sortConstantRateMoneyCategories();
          // console.log("getConstantRate : ", resultData);
        }
      });
    },
    async getConstantRateMoney() {
      await this.getConstantRate();
      let data = this.$store.state.main.moneyCategories;
      if (this.ConstantRateMoneyCategories.length == 0) {
        for (var i = 0; i < data.length; i++) {
          this.ConstantRateMoneyCategories.push({
            id: i,
            code: data[i].code,
            inRate: 0.0,
            outRate: 0.0,
            minRateThreshold: 0,
            specialRate: 0.0,
          });
        }
      }
      this.sortConstantRateMoneyCategories();
      await this.updateRegistersCurrency();
    },
    async onChangeInputRate(event, id) {
      const item = this.tempConstantRateMoenyCategories[id];
      item.inRate = this.$h.onlyNumberAndDot(item.inRate);
      item.outRate = this.$h.onlyNumberAndDot(item.outRate);
      item.minRateThreshold = this.$h.onlyNumberAndDot(item.minRateThreshold);
      item.specialRate = this.$h.onlyNumberAndDot(item.specialRate);
    },
    async updateConstantRate() {
      // console.log("저장 직전 배열 상태:", this.tempConstantRateMoenyCategories);
      let data = {
        adminId: this.$store.state.auth.user.id,
        agencyId: this.$store.state.auth.user.agencyId,
        token: this.$h.assign(this.$store.state.auth.user.token),
        constRate: JSON.stringify(this.tempConstantRateMoenyCategories)
      };
      await axios.post(this.$api().updateConstantRate, data);
    },
    sortConstantRateMoneyCategories() {
      const order = [
        "USD",
        "JPY",
        "HKD",
        "TWD",
        "EUR",
        "CNY",
        "SGD",
        "GBP",
        "CAD",
        "PHP",
        "THB",
        "AUD",
        "NZD",
        "MYR",
        "RUB",
        "CHF",
        "VND",
        "OTH"
      ];
      this.ConstantRateMoneyCategories.sort((a, b) => {
        return order.indexOf(a.code) - order.indexOf(b.code);
      });
    },
    async updateConstantRateMoney() {
      await this.updateConstantRate();
    },
    async updateRegistersCurrency() {
      for (var index = 0; index < this.registers.length; index++) {
        if (this.registers[index].isDisableRate) return;
        for (var i = 0; i < this.ConstantRateMoneyCategories.length; i++) {
          if (String(this.registers[index].moneyCategoryCode) == String(this.ConstantRateMoneyCategories[i].code)) {
        
            // [수정] 매입(1)일 때만 우대환율 체크
            if (this.register.exchangeType == 1) {
              if (this.ConstantRateMoneyCategories[i].specialRate && Number(this.ConstantRateMoneyCategories[i].specialRate) > 0) {
                this.registers[index].inRate = this.ConstantRateMoneyCategories[i].specialRate;
              } else {
                this.registers[index].inRate = this.ConstantRateMoneyCategories[i].inRate;
              }
            } else if (this.register.exchangeType == 2) {
              this.registers[index].outRate = this.ConstantRateMoneyCategories[i].outRate;
            }
          }
        }

        let localCurrency = 0;
        if (this.register.exchangeType == 1) {
          localCurrency = Math.round(
            this.registers[index].foreignCurrency * this.registers[index].inRate
          );
          this.registers[index].localOrignCurrency = Math.round(
            this.registers[index].foreignCurrency * this.registers[index].inRate
          );
        } else {
          localCurrency = Math.round(
            this.registers[index].foreignCurrency *
              this.registers[index].outRate
          );
          this.registers[index].localOrignCurrency = Math.round(
            this.registers[index].foreignCurrency *
              this.registers[index].outRate
          );
        }
        if (this.registers[index].cutAmount != 0) {
          const modVal = localCurrency % this.registers[index].cutAmount;
          // type = 1 : 절상, type = 2 : 절하
          if (this.register.exchangeType == 1) {
            localCurrency = localCurrency - modVal;
            localCurrency += this.registers[index].cutAmount;
          } else {
            if (modVal == 0) {
              localCurrency -= this.registers[index].cutAmount;
            } else {
              localCurrency = localCurrency - modVal;
            }
          }
        }
        this.registers[index].localCurrency = localCurrency;
        //console.log("localCurrency : ", this.registers[index].localCurrency);
        // console.log(
        //   "localOriginalCurrency : ",
        //   this.registers[index].localOrignCurrency
        // );
        this.onChangeInputLocalCurrency(index);
      }
    },
    async ConfirmConstantRate() {
      // 1. 중복 클릭 방지 (isRateUpdating 활용)
      if (this.isRateUpdating) return;

      try {
        await this.updateConstantRateMoney();
        await this.handleRateUpdate();
        this.hideModal();

        console.log("소켓 상태:", this.socket.connected);
        console.log("신호 보냄: refresh_request");
        this.socket.emit('refresh_request');
      } catch (error) {
        console.error("환율 저장 중 에러 발생:", error);
        alert("환율 저장에 실패했습니다. 다시 시도해 주세요.");
      } finally {
        this.isRateUpdating = false;
      }
    },
    async getCountries() {
      let data = {
        token: this.$h.assign(this.$store.state.auth.user.token)
      };
      await axios.post(this.$api().getCountries, data).then(res => {
        let resultData = this.$h.assign(res.data);
        this.countries = resultData.data;
        this.tmpCountries = [...this.countries];
      });
    },
    handleExchangeType(val) {
      this.init();
      this.register.exchangeType = val;
      for (var index = 0; index < this.registers.length; index++) {
        for (var i = 0; i < this.ConstantRateMoneyCategories.length; i++) {
          const category = this.ConstantRateMoneyCategories[i];
      
          if (String(this.registers[index].moneyCategoryCode) == String(category.code)) {
            
            if (this.register.exchangeType == 1) { // 외화 -> 원화 (매입)
              // 우대환율이 0보다 크면 우대환율 적용, 아니면 일반 매입가
              if (category.specialRate && Number(category.specialRate) > 0) {
                this.registers[index].inRate = category.specialRate;
              } else {
                this.registers[index].inRate = category.inRate;
              }
            } else if (this.register.exchangeType == 2) { // 원화 -> 외화 (매도)
              // 매도는 무조건 일반 매도값
              this.registers[index].outRate = category.outRate;
            }
          }
        }
      }
    },
    init() {
      this.selectedIndex = 0;
      this.register.nationalityName = "";
      this.register.userName = "";
      this.register.nationality = "";
      this.register.passportNo = "";
      this.register.residenceNo = "";
      this.register.foreignResidenceNo = "";
      this.register.others = "";
      const tmpRegister = [
        {
          inRate: "",
          outRate: "",
          foreignCurrency: "",
          localCurrency: "",
          localOrignCurrency: 0,
          cutAmount: 0,
          moneyCategoryCode: "USD",
          moneyCategoryUnit: "$ ",
          optionValue1: false,
          optionValue2: false,
          optionValue3: false,
          optionValue4: false,
          optionValue5: false,
          optionValue6: false,
          optionValue7: false,
          isDisableRate: false
        }
      ];
      this.registers = [...tmpRegister];
      const tmpPrintDatas = [
        {
          foreignCurrency: "",
          rate: "",
          result: ""
        }
      ];
      this.printDatas = [...tmpPrintDatas];
      this.initOptions(0, 0);
      this.selectMoneyItem(
        this.selectedMoneyCategoryCode,
        this.selectedMoneyCategoryUnit
      );
      this.onChangeInputForeignCurrency(null, 0);
    },
    async validate() {
      let msg = "";
      let flag = false;
      await this.registers.forEach(row => {
        if (this.$h.isEmpty(row.localCurrency) || row.localCurrency == 0) {
          msg = "외화금액과 환율을 입력해주세요.";
          flag = true;
        }
      });
      if (flag) {
        Toastify({
          text: msg,
          duration: 3000,
          newWindow: true,
          close: true,
          gravity: "top",
          position: "right",
          backgroundColor: "#0e2c88",
          stopOnFocus: true
        }).showToast();
      }
      return flag;
    },
    async handleCancel() {
      this.modalFlag = false;
      cash("#confirm-modal-preview").modal("hide");
    },
    async handleUserHistoryCount(
      username,
      nationality,
      passportNo,
      registerenceId
    ) {
      // // console.log("store user ; ", this.$store.state.auth.user);
      let data = {
        token: this.$h.assign(this.$store.state.auth.user.token),
        username: username,
        nationality: nationality,
        passportNo: passportNo,
        residenceNo: registerenceId,
        agencyId: this.$store.state.auth.user.agencyId,
        exchangeType: this.register.exchangeType
      };
      await axios.post(this.$api().getHistoryCount, data).then(res => {
        if (res.status == 200) {
          this.historyCount = res.data.count;
          // console.log("historyCount : ", this.historyCount);
        } else {
          // console.log("there is no collected data for history");
        }
      });
    },
    async handleRegister() {
      if (this.isProcessing) return;
      // --- [실시간 환율 기반] 허용 오차 체크 로직 ---
      for (let i = 0; i < this.registers.length; i++) {
        const regItem = this.registers[i];

        // [보완] 대소문자와 공백을 제거하고 정확하게 비교
        const realTimeRate = this.$store.state.main.moneyCategories.find(
          c =>
            String(c.code)
              .trim()
              .toUpperCase() ===
            String(regItem.moneyCategoryCode)
              .trim()
              .toUpperCase()
        );

        const thresholdSetting = this.ConstantRateMoneyCategories.find(
          c =>
            String(c.code)
              .trim()
              .toUpperCase() ===
            String(regItem.moneyCategoryCode)
              .trim()
              .toUpperCase()
        );

        // [보완] 확실하게 숫자로 변환
        const minThreshold = Number(thresholdSetting?.minRateThreshold) || 0;

        if (realTimeRate && minThreshold > 0) {
          const baseRate = Number(realTimeRate.otherToKwrRate);

          const inputRate =
            this.register.exchangeType == 1
              ? Number(regItem.inRate)
              : Number(regItem.outRate);

          if (baseRate > 0 && inputRate > 0) {
            const diffPercent =
              (Math.abs(inputRate - baseRate) / baseRate) * 100;

            if (!isNaN(diffPercent) && diffPercent > minThreshold) {
              const minAllowedRate = (
                baseRate *
                (1 - minThreshold / 100)
              ).toFixed(2);
              const maxAllowedRate = (
                baseRate *
                (1 + minThreshold / 100)
              ).toFixed(2);

              const confirmMsg =
                `[실시간 환율 경고] ${regItem.moneyCategoryCode} 환율이 시장가와 차이가 큽니다.\n` +
                `시장가(실시간): ${baseRate} / 입력가: ${inputRate}\n` +
                `현재 오차: ${diffPercent.toFixed(
                  2
                )}% (허용: ${minThreshold}%)\n\n` +
                `허용 환율 범위: ${minAllowedRate} ~ ${maxAllowedRate}\n` +
                `이대로 진행하시겠습니까?`;

              if (!confirm(confirmMsg)) {
                this.isProcessing = false;
                this.hideLoading();
                return;
              }
            }
          }
        }
      }
      // --- [추가] 허용 오차 체크 로직 끝 ---

      this.isProcessing = true;

      if (
        document.activeElement &&
        document.activeElement instanceof HTMLElement
      ) {
        document.activeElement.blur();
      }

      try {
        this.modalFlag = false;
        this.historyCount = 0;
        cash("#confirm-modal-preview").modal("hide");

        let successCnt = 0;
        let error = "오류";
        this.showLoading();

        for (let i = 0; i < this.registers.length; i++) {
          let registerItem = this.registers[i];
          let data = {
            adminId: this.$store.state.auth.user.id,
            userName: this.register.userName,
            nationality: this.register.nationality,
            passportNo: this.register.passportNo,
            residenceNo: this.register.residenceNo,
            noType: this.getNoType(),
            foreignResidenceNo: this.register.foreignResidenceNo,
            others: this.register.others,
            exchangeType: this.register.exchangeType,
            inRate: registerItem.inRate,
            outRate: registerItem.outRate,
            moneyCategoryCode: registerItem.moneyCategoryCode,
            foreignCurrency:
              registerItem.moneyCategoryCode === "JPY"
                ? registerItem.foreignCurrency.toFixed(4)
                : registerItem.foreignCurrency.toFixed(2),
            localCurrency: registerItem.localCurrency,
            localOrignCurrency: registerItem.localOrignCurrency,
            token: this.$h.assign(this.$store.state.auth.user.token),
            cutAmount: registerItem.cutAmount
          };

          const res = await axios.post(this.$api().addTransaction, data);
          if (res.status == 200) {
            successCnt++;
          } else {
            error = res.data.data;
          }
        }

        this.hideLoading();

        if (successCnt == this.registers.length) {
          this.init();
          Toastify({
            text: "영수증 출력이 완료되었습니다.",
            duration: 3000,
            backgroundColor: "#0e2c88",
            position: "right"
          }).showToast();

          // [핵심 보완] 인쇄창 콜백이 누락될 경우를 대비한 '강제 해제' 타이머
          // 인쇄창이 뜨고 나서 3초 뒤에는 콜백 여부와 상관없이 플래그를 풉니다.
          const safetyTimer = setTimeout(() => {
            if (this.isProcessing) {
              console.log("Safety timer triggered: Releasing lock.");
              this.isProcessing = false;
            }
          }, 3000);

          printJS({
            printable: "printArea",
            type: "html",
            css: ["/print.css"],
            scanStyles: false,
            onPrintDialogClose: () => {
              // 콜백이 정상 작동하면 타이머 취소
              clearTimeout(safetyTimer);
              this.$nextTick(() => {
                const nextInput = document.querySelector("#userNameInput");
                if (nextInput) nextInput.focus();
                setTimeout(() => {
                  this.isProcessing = false;
                }, 500);
              });
            }
          });
        } else {
          Toastify({
            text: error,
            backgroundColor: "#e53231",
            position: "right"
          }).showToast();
          this.isProcessing = false;
        }
      } catch (err) {
        console.error(err);
        this.isProcessing = false;
        this.hideLoading();
      } finally {
        cash("#confirm-modal-preview").modal("hide");
      }
    },
    selectMoneyItem(moneyCategoryCode, moneyCategoryUnit) {
      this.selectedMoneyCategoryCode = moneyCategoryCode;
      this.registers[
        this.selectedIndex
      ].moneyCategoryCode = this.selectedMoneyCategoryCode;
      this.selectedMoneyCategoryUnit = moneyCategoryUnit;
      this.registers[this.selectedIndex].moneyCategoryUnit =
        this.selectedMoneyCategoryUnit + " ";
      this.registers[this.selectedIndex].foreignCurrencyStr =
        this.registers[this.selectedIndex].moneyCategoryUnit +
        this.registers[this.selectedIndex].foreignCurrency.toLocaleString();
      this.registers[this.selectedIndex].isDisableRate = false;
      for (var i = 0; i < this.ConstantRateMoneyCategories.length; i++) {
        const category = this.ConstantRateMoneyCategories[i];
        if (String(this.registers[this.selectedIndex].moneyCategoryCode) == String(category.code)) {
          
          // [수정] 매입(1)일 때만 우대환율 체크
          if (this.register.exchangeType == 1) {
            if (category.specialRate && Number(category.specialRate) > 0) {
              this.registers[this.selectedIndex].inRate = category.specialRate;
            } else {
              this.registers[this.selectedIndex].inRate = category.inRate;
            }
          } 
          // 매도(2)일 때는 우대환율이 있어도 무조건 일반 outRate 사용
          else if (this.register.exchangeType == 2) {
            this.registers[this.selectedIndex].outRate = category.outRate;
          }
        }
      }
      let localCurrency = 0;
      if (this.register.exchangeType == 1) {
        localCurrency = Math.round(
          this.registers[this.selectedIndex].foreignCurrency *
            this.registers[this.selectedIndex].inRate
        );
        this.registers[this.selectedIndex].localOrignCurrency = Math.round(
          this.registers[this.selectedIndex].foreignCurrency *
            this.registers[this.selectedIndex].inRate
        );
      } else {
        localCurrency = Math.round(
          this.registers[this.selectedIndex].foreignCurrency *
            this.registers[this.selectedIndex].outRate
        );
        this.registers[this.selectedIndex].localOrignCurrency = Math.round(
          this.registers[this.selectedIndex].foreignCurrency *
            this.registers[this.selectedIndex].outRate
        );
      }
      if (this.registers[this.selectedIndex].cutAmount != 0) {
        const modVal =
          localCurrency % this.registers[this.selectedIndex].cutAmount;
        // type = 1 : 절상, type = 2 : 절하
        if (this.register.exchangeType == 1) {
          localCurrency = localCurrency - modVal;
          localCurrency += this.registers[this.selectedIndex].cutAmount;
        } else {
          if (modVal == 0) {
            localCurrency -= this.registers[this.selectedIndex].cutAmount;
          } else {
            localCurrency = localCurrency - modVal;
          }
        }
      }
      this.registers[this.selectedIndex].localCurrency = localCurrency;
      // console.log(
      //   "localCurrency : ",
      //   this.registers[this.selectedIndex].localCurrency
      // );
      // console.log(
      //   "localOriginalCurrency : ",
      //   this.registers[this.selectedIndex].localOrignCurrency
      // );
      this.onChangeInputLocalCurrency(this.selectedIndex);
      this.setAutoFocus(this.registers.length - 1);
    },
    showLoading() {
      this.$store.dispatch("main/setLoading", true);
    },
    hideLoading() {
      this.$store.dispatch("main/setLoading", false);
    },
    async showShortKeyModal() {
      // console.log("admin Info : ", this.$store.state.auth.user);
      await this.getShortKeysResiger();
      cash("#shortKey_modal").modal("toggle");
    },
    showConstantRateModal() {
      console.log("원본 데이터 확인:", this.ConstantRateMoneyCategories); // 데이터가 있는지 콘솔 확인

      this.tempConstantRateMoenyCategories = [];

      // 데이터가 존재할 때만 실행되도록 방어 코드 추가
      if (
        this.ConstantRateMoneyCategories &&
        this.ConstantRateMoneyCategories.length > 0
      ) {
        this.tempConstantRateMoenyCategories = this.ConstantRateMoneyCategories.map(
          item => ({
            id: item.id,
            code: item.code,
            inRate: item.inRate,
            outRate: item.outRate,
            // (중요) 값이 "0"(문자열)이거나 null일 경우를 대비해 더 강력하게 체크
            minRateThreshold:
              item.minRateThreshold !== undefined &&
              item.minRateThreshold !== null
                ? item.minRateThreshold
                : 0,
            specialRate: item.specialRate,
          })
        );
      }

      console.log("매핑된 데이터 확인:", this.tempConstantRateMoenyCategories);
      cash("#constant_CurrencyRate_modal").modal("toggle");
    },
    // 1. methods 내부에 화살표 이동 로직 추가
    handleArrowKey(direction) {
      const categories = this.$store.state.main.moneyCategories;
      if (!categories || categories.length === 0) return;

      const total = categories.length;
      let currentIndex = categories.findIndex(c => c.code === this.selectedMoneyCategoryCode);
      if (currentIndex === -1) currentIndex = 0;

      // 1. 현재 화면 크기에 따른 한 줄당 아이템 개수(cols) 판별
      // tailwind xxl: 1600px 이상(6개), sm: 640px 이상(4개), 그 외(1개)
      // 프로젝트의 실제 breakpoints 설정에 따라 숫자를 미세 조정하세요.
      const width = window.innerWidth;
      let cols = 1;
      if (width >= 1600) {
        cols = 6;
      } else if (width >= 640) {
        cols = 4;
      } else {
        cols = 1;
      }

      let nextIndex = currentIndex;

      switch (direction) {
        case "ArrowRight":
          nextIndex = (currentIndex + 1) % total;
          break;
        case "ArrowLeft":
          nextIndex = (currentIndex - 1 + total) % total;
          break;
        case "ArrowDown":
          nextIndex = currentIndex + cols;
          // 아래로 갈 때 범위를 벗어나면 이동하지 않거나, 
          // 사용자 편의를 위해 마지막 줄의 해당 열에서 멈춤
          if (nextIndex >= total) return; 
          break;
        case "ArrowUp":
          nextIndex = currentIndex - cols;
          // 위로 갈 때 0보다 작으면 이동하지 않음
          if (nextIndex < 0) return;
          break;
      }

      // 2. 인덱스 이동 실행
      if (nextIndex !== currentIndex && categories[nextIndex]) {
        const nextCategory = categories[nextIndex];
        this.selectMoneyItem(nextCategory.code, nextCategory.unit);
      }
    },
    enableManualRate(index) {
      //console.log("enableManualRate : ", index);
      // 수동설정 활성화
      if (this.registers[index].isDisableRate) {
        return; // 이미 수동설정이 활성화된 경우 중복 호출 방지
      }

      // 수동설정 활성화
      this.registers[index].isDisableRate = true;

      if (this.register.exchangeType == 1) {
        this.registers[index].inRate = null;
      } else {
        this.registers[index].outRate = null;
      }
      let localCurrency = 0;
      if (this.register.exchangeType == 1) {
        localCurrency = 0;
        this.registers[index].localOrignCurrency = 0;
      } else {
        localCurrency = 0;
        this.registers[index].localOrignCurrency = 0;
      }
      if (this.registers[index].cutAmount != 0) {
        const modVal = localCurrency % this.registers[index].cutAmount;
        // type = 1 : 절상, type = 2 : 절하
        if (this.register.exchangeType == 1) {
          localCurrency = localCurrency - modVal;
          localCurrency += this.registers[index].cutAmount;
        } else {
          if (modVal == 0) {
            localCurrency -= this.registers[index].cutAmount;
          } else {
            localCurrency = localCurrency - modVal;
          }
        }
      }
      this.registers[index].localCurrency = localCurrency;
      this.onChangeInputLocalCurrency(index);
      setTimeout(() => {
        jQuery(`#inputRate${index}`).focus();
      }, 10);
    },
    clickConstantBtn(index) {
      //console.log("isDisableRate : ", this.registers[index].isDisableRate);
      if (!this.registers[index].isDisableRate) {
        for (var i = 0; i < this.ConstantRateMoneyCategories.length; i++) {
          if (String(this.registers[index].moneyCategoryCode) == String(this.ConstantRateMoneyCategories[i].code)) {
        
            // [수정] 매입(1)일 때만 우대환율 체크
            if (this.register.exchangeType == 1) {
              if (this.ConstantRateMoneyCategories[i].specialRate && Number(this.ConstantRateMoneyCategories[i].specialRate) > 0) {
                this.registers[index].inRate = this.ConstantRateMoneyCategories[i].specialRate;
              } else {
                this.registers[index].inRate = this.ConstantRateMoneyCategories[i].inRate;
              }
            } 
            // 매도(2)일 때는 무조건 일반 outRate
            else if (this.register.exchangeType == 2) {
              this.registers[index].outRate = this.ConstantRateMoneyCategories[i].outRate;
            }
          }
        }
        let localCurrency = 0;
        if (this.register.exchangeType == 1) {
          localCurrency = Math.round(
            this.registers[index].foreignCurrency * this.registers[index].inRate
          );
          this.registers[index].localOrignCurrency = Math.round(
            this.registers[index].foreignCurrency * this.registers[index].inRate
          );
        } else {
          localCurrency = Math.round(
            this.registers[index].foreignCurrency *
              this.registers[index].outRate
          );
          this.registers[index].localOrignCurrency = Math.round(
            this.registers[index].foreignCurrency *
              this.registers[index].outRate
          );
        }
        if (this.registers[index].cutAmount != 0) {
          const modVal = localCurrency % this.registers[index].cutAmount;
          // type = 1 : 절상, type = 2 : 절하
          if (this.register.exchangeType == 1) {
            localCurrency = localCurrency - modVal;
            localCurrency += this.registers[index].cutAmount;
          } else {
            if (modVal == 0) {
              localCurrency -= this.registers[index].cutAmount;
            } else {
              localCurrency = localCurrency - modVal;
            }
          }
        }
        this.registers[index].localCurrency = localCurrency;
        this.onChangeInputLocalCurrency(index);
        // console.log(
        //   "localCurrency : ",
        //   this.registers[this.selectedIndex].localCurrency
        // );
        // console.log(
        //   "localOriginalCurrency : ",
        //   this.registers[this.selectedIndex].localOrignCurrency
        // );
        return;
      }
      if (this.register.exchangeType == 1) {
        this.registers[index].inRate = null;
      } else {
        this.registers[index].outRate = null;
      }
      let localCurrency = 0;
      if (this.register.exchangeType == 1) {
        localCurrency = 0;
        this.registers[index].localOrignCurrency = 0;
      } else {
        localCurrency = 0;
        this.registers[index].localOrignCurrency = 0;
      }
      if (this.registers[index].cutAmount != 0) {
        const modVal = localCurrency % this.registers[index].cutAmount;
        // type = 1 : 절상, type = 2 : 절하
        if (this.register.exchangeType == 1) {
          localCurrency = localCurrency - modVal;
          localCurrency += this.registers[index].cutAmount;
        } else {
          if (modVal == 0) {
            localCurrency -= this.registers[index].cutAmount;
          } else {
            localCurrency = localCurrency - modVal;
          }
        }
      }
      this.registers[index].localCurrency = localCurrency;
      this.onChangeInputLocalCurrency(index);
      setTimeout(() => {
        jQuery(`#inputRate${index}`).focus();
      }, 10);
      // console.log(
      //   "localCurrency : ",
      //   this.registers[this.selectedIndex].localCurrency
      // );
      // console.log(
      //   "localOriginalCurrency : ",
      //   this.registers[this.selectedIndex].localOrignCurrency
      // );
    },
    async hideShortKeyModal() {
      cash("#shortKey_modal").modal("hide");
    },
    async hideModal() {
      cash("#constant_CurrencyRate_modal").modal("hide");
    },
    async clickDeleteShortKeyBtn(id) {
      this.shortKeyResigers = this.shortKeyResigers
        .filter(item => item.id !== id)
        .map((item, index) => ({ ...item, id: index + 1 })); // index + 1
      // console.log("shortKeyResigers : ", this.shortKeyResigers);
      this.tempShortKeyResigers = {
        id: 0,
        key: "",
        value: ""
      };
    },
    async getShortKeysResiger() {
      this.shortKeyResigers = [];
      let data = {
        adminId: this.$store.state.auth.user.id,
        token: this.$h.assign(this.$store.state.auth.user.token)
      };
      await axios.post(this.$api().getShortKey, data).then(res => {
        // console.log("getShortKeyResiger res : ", res.status);
        if (res.status == 200) {
          this.shortKeyResigers = JSON.parse(res.data.data.key_combination);
          // console.log("getupdateShortKeys : ", this.shortKeyResigers);
        }
      });
    },
    async hideShortKeyBtn() {
      await this.hideModal();
      await this.getShortKeysResiger();
    },
    isIntegerString(value) {
      return typeof value === "string" && /^\d+$/.test(value);
    },
    async updateConfirmShortKeyResiger() {
      this.hideShortKeyModal();
      let data = {
        adminId: this.$store.state.auth.user.id,
        token: this.$h.assign(this.$store.state.auth.user.token),
        shortKeys: JSON.stringify(this.shortKeyResigers)
      };
      this.shortKeyResigers = [];
      await axios.post(this.$api().updateShortKey, data).then(res => {
        // console.log("updateShortKeyResiger res : ", res.status);
        if (res.status == 200) {
          this.shortKeyResigers = JSON.parse(res.data.data.key_combination);
          Toastify({
            text: "단축키 설정이 완료되었습니다.",
            duration: 3000,
            newWindow: true,
            close: true,
            gravity: "top",
            position: "right",
            backgroundColor: "#0e2c88",
            stopOnFocus: true
          }).showToast();
        } else {
          Toastify({
            text: "단축키 설정이 실패하였습니다.",
            duration: 3000,
            newWindow: true,
            close: true,
            gravity: "top",
            position: "right",
            backgroundColor: "#e53231",
            stopOnFocus: true
          }).showToast();
        }
      });
    },
    async onChangeInputShortKey(event) {
      this.tempShortKeyResigers.key = event.code;
      // console.log("inputValue : ", this.tempShortKeyResigers.key);
    },
    async addShortKeyResiger() {
      if (this.tempShortKeyResigers.key == "") {
        Toastify({
          text: "지정키를 입력해주세요.",
          duration: 3000,
          newWindow: true,
          close: true,
          gravity: "top",
          position: "right",
          backgroundColor: "#e53231",
          stopOnFocus: true
        }).showToast();
        return;
      }
      if (this.tempShortKeyResigers.value == "") {
        Toastify({
          text: "입력값을 입력해주세요.",
          duration: 3000,
          newWindow: true,
          close: true,
          gravity: "top",
          position: "right",
          backgroundColor: "#e53231",
          stopOnFocus: true
        }).showToast();
        return;
      }
      if (!this.isIntegerString(this.tempShortKeyResigers.value)) {
        Toastify({
          text: "입력값을 숫자로 입력해주세요.",
          duration: 3000,
          newWindow: true,
          close: true,
          gravity: "top",
          position: "right",
          backgroundColor: "#e53231",
          stopOnFocus: true
        }).showToast();
        this.tempShortKeyResigers.key = "";
        this.tempShortKeyResigers.value = "";
        return;
      }
      this.tempShortKeyResigers.id = this.shortKeyResigers.length + 1;
      this.shortKeyResigers.push(this.tempShortKeyResigers);
      this.tempShortKeyResigers = {
        id: 0,
        key: "",
        value: ""
      };
      setTimeout(() => {
        jQuery(`#shortKeyRegister_key`).focus();
      }, 10);
      // console.log("shortKeyResigers : ", this.shortKeyResigers);
    },
    onClickOption(type, index) {
      //console.log("type : ", type, " index : ", index);
      if (type == 1) {
        // console.log(
        //   "this.registers[index].optionValue1 : ",
        //   this.registers[index].optionValue1
        // );
        if (this.registers[index].optionValue1 == true) {
          //console.log("123");
          this.initOptions(1, index);
          this.registers[index].cutAmount = 10;
          this.initLocalCurrency(index);
        } else {
          //console.log("456");
          this.initOptions(0, index);
          this.registers[index].cutAmount = 0;
          this.initOrignLocalCurrency(index);
        }
      } else if (type == 2) {
        if (this.registers[index].optionValue2 == true) {
          this.initOptions(2, index);
          this.registers[index].cutAmount = 50;
          this.initLocalCurrency(index);
        } else {
          this.initOptions(0, index);
          this.registers[index].cutAmount = 0;
          this.initOrignLocalCurrency(index);
        }
      } else if (type == 3) {
        if (this.registers[index].optionValue3 == true) {
          this.initOptions(3, index);
          this.registers[index].cutAmount = 100;
          this.initLocalCurrency(index);
        } else {
          this.initOptions(0, index);
          this.registers[index].cutAmount = 0;
          this.initOrignLocalCurrency(index);
        }
      } else if (type == 4) {
        if (this.registers[index].optionValue4 == true) {
          this.initOptions(4, index);
          this.registers[index].cutAmount = 500;
          this.initLocalCurrency(index);
        } else {
          this.initOptions(0, index);
          this.registers[index].cutAmount = 0;
          this.initOrignLocalCurrency(index);
        }
      } else if (type == 5) {
        if (this.registers[index].optionValue5 == true) {
          this.initOptions(5, index);
          this.registers[index].cutAmount = 1000;
          //this.initLocalCurrency(index);
        } else {
          this.initOptions(0, index);
          this.registers[index].cutAmount = 0;
          this.initOrignLocalCurrency(index);
        }
      } else if (type == 6) {
        if (this.registers[index].optionValue6 == true) {
          this.initOptions(6, index);
          this.registers[index].cutAmount = 5000;
          this.initLocalCurrency(index);
        } else {
          this.initOptions(0, index);
          this.registers[index].cutAmount = 0;
          this.initOrignLocalCurrency(index);
        }
      } else if (type == 7) {
        if (this.registers[index].optionValue7 == true) {
          this.initOptions(7, index);
          this.registers[index].cutAmount = 10000;
          //this.initLocalCurrency(index);
        } else {
          this.initOptions(0, index);
          this.registers[index].cutAmount = 0;
          this.initOrignLocalCurrency(index);
        }
      }
    },
    initLocalCurrency(index) {
      // =================================
      // :    init localCutCurrency
      // =================================
      // this.registers[index].localCutCurrency = this.$h.filterCurrency(
      //   this.$h.cutNumber(
      //     this.registers[index].localCurrency,
      //     this.registers[index].cutAmount,
      //     this.register.exchangeType
      //   )
      // );
      let localCurrency = 0;
      if (this.register.exchangeType == 1) {
        localCurrency = Math.round(
          this.registers[index].foreignCurrency * this.registers[index].inRate
        );
      } else {
        localCurrency = Math.round(
          this.registers[index].foreignCurrency * this.registers[index].outRate
        );
      }
      if (this.registers[index].cutAmount != 0) {
        const modVal = localCurrency % this.registers[index].cutAmount;
        // type = 1 : 절상, type = 2 : 절하
        if (this.register.exchangeType == 1) {
          localCurrency = localCurrency - modVal;
          localCurrency += this.registers[index].cutAmount;
        } else {
          if (modVal == 0) {
            localCurrency -= this.registers[index].cutAmount;
          } else {
            localCurrency = localCurrency - modVal;
          }
        }
      }
      this.registers[index].localCurrency = localCurrency;
      this.onChangeInputLocalCurrency(index);
      // console.log("localCurrency : ", this.registers[index].localCurrency);
      // console.log(
      //   "localOriginalCurrency : ",
      //   this.registers[index].localOrignCurrency
      // );
      // =================================
      // :    init localCurrency
      // =================================
      // this.registers[index].localCurrency = this.$h.convertCommaStrToInt(
      //   this.registers[index].localCutCurrency
      // );
    },
    initOrignLocalCurrency(index) {
      // =================================
      // :    init localCurrency
      // =================================
      if (this.register.exchangeType == 1) {
        this.registers[index].localCurrency = Math.round(
          this.registers[index].foreignCurrency * this.registers[index].inRate
        );
        this.registers[index].localOrignCurrency = Math.round(
          this.registers[index].foreignCurrency * this.registers[index].inRate
        );
      } else {
        this.registers[index].localCurrency = Math.round(
          this.registers[index].foreignCurrency * this.registers[index].outRate
        );
        this.registers[index].localOrignCurrency = Math.round(
          this.registers[index].foreignCurrency * this.registers[index].outRate
        );
      }
      this.onChangeInputLocalCurrency(index);
      // console.log(
      //   "this.registers-",
      //   index,
      //   " : ",
      //   this.registers[index].localCurrency
      // );
    },
    onForeignEnterKeyPressed(index) {
      if (!this.registers[index].isDisableRate) {
        let rate = 0;
        if (this.register.exchangeType == 1) {
          rate = this.registers[index].inRate;
        } else if (this.register.exchangeType == 2) {
          rate = this.registers[index].outRate;
        }
        //console.log("rate : ", rate);
        if (rate != 0) {
          this.confirmRegister();
        } else {
          this.registers[index].isDisableRate = true;
          setTimeout(() => {
            jQuery(`#inputRate${index}`).focus();
          }, 10);
        }
      } else {
        setTimeout(() => {
          jQuery(`#inputRate${index}`).focus();
        }, 10);
      }
    },
    async confirmRegister() {
      // console.log("영수증출력 1 !");
      let rst = await this.validate();
      if (rst == true) {
        return;
      }
      if (this.modalFlag == true) {
        this.handleRegister();
      } else {
        this.modalFlag = true;
        cash("#confirm-modal-preview").modal("toggle");
      }
    },
    onKeyUpForeignCurrency(event, index) {
      const keypadValue = event.code;
      for (var i = 0; i < this.shortKeyResigers.length; i++) {
        const item = this.shortKeyResigers[i];
        if (String(keypadValue) === String(item.key)) {
          this.registers[index].foreignCurrency = parseInt(String(item.value));
          this.registers[index].foreignCurrencyStr =
            this.registers[index].moneyCategoryUnit +
            this.registers[index].foreignCurrency.toLocaleString(); // 통화 형식으로 포맷팅
        }
      }
      let localCurrency = 0;
      if (this.register.exchangeType == 1) {
        localCurrency = Math.round(
          this.registers[index].foreignCurrency * this.registers[index].inRate
        );
        this.registers[index].localOrignCurrency = Math.round(
          this.registers[index].foreignCurrency * this.registers[index].inRate
        );
      } else {
        localCurrency = Math.round(
          this.registers[index].foreignCurrency * this.registers[index].outRate
        );
        this.registers[index].localOrignCurrency = Math.round(
          this.registers[index].foreignCurrency * this.registers[index].outRate
        );
      }
      if (this.registers[index].cutAmount != 0) {
        const modVal = localCurrency % this.registers[index].cutAmount;
        // type = 1 : 절상, type = 2 : 절하
        if (this.register.exchangeType == 1) {
          localCurrency = localCurrency - modVal;
          localCurrency += this.registers[index].cutAmount;
        } else {
          if (modVal == 0) {
            localCurrency -= this.registers[index].cutAmount;
          } else {
            localCurrency = localCurrency - modVal;
          }
        }
      }
      this.registers[index].localCurrency = localCurrency;
      this.onChangeInputLocalCurrency(index);
    },
    onChangeInputForeignCurrency(event, index) {
      this.registers[index].inRate = this.$h.onlyNumberAndDot(
        this.registers[index].inRate
      );
      this.registers[index].outRate = this.$h.onlyNumberAndDot(
        this.registers[index].outRate
      );
      // if (this.registers[index].foreignCurrency == 0) {
      //   this.registers[index].localCurrency = 0;
      //   return;
      // }
      const numericValue = parseInt(
        this.registers[index].foreignCurrencyStr.replace(/[^0-9]/g, "")
      ); // 숫자만 추출
      if (!isNaN(numericValue)) {
        this.registers[index].foreignCurrency = numericValue;
        this.registers[index].foreignCurrencyStr =
          this.registers[index].moneyCategoryUnit +
          numericValue.toLocaleString(); // 통화 형식으로 포맷팅
      } else {
        // console.log("NAN called");
        this.registers[index].foreignCurrency = 0;
        this.registers[index].foreignCurrencyStr = "";
      }
      // =================================
      // :    init localCurrency
      // =================================

      let localCurrency = 0;
      if (this.register.exchangeType == 1) {
        localCurrency = Math.round(
          this.registers[index].foreignCurrency * this.registers[index].inRate
        );
      } else {
        localCurrency = Math.round(
          this.registers[index].foreignCurrency * this.registers[index].outRate
        );
      }
      if (this.registers[index].cutAmount != 0) {
        const modVal = localCurrency % this.registers[index].cutAmount;
        // type = 1 : 절상, type = 2 : 절하
        if (this.register.exchangeType == 1) {
          localCurrency = localCurrency - modVal;
          localCurrency += this.registers[index].cutAmount;
        } else {
          if (modVal == 0) {
            localCurrency -= this.registers[index].cutAmount;
          } else {
            localCurrency = localCurrency - modVal;
          }
        }
      }

      this.registers[index].localCurrency = localCurrency;
      // =================================
      // :    init localOrignCurrency
      // =================================
      if (this.register.exchangeType == 1) {
        this.registers[index].localOrignCurrency = Math.round(
          this.registers[index].foreignCurrency * this.registers[index].inRate
        );
      } else {
        this.registers[index].localOrignCurrency = Math.round(
          this.registers[index].foreignCurrency * this.registers[index].outRate
        );
      }
      this.onChangeInputLocalCurrency(index);
    },
    onChangeInputLocalCurrency(index) {
      //this.initOptions(0, index);
      // =======================================================
      // :                  printData start
      // =======================================================
      this.printData.printedDate = moment(new Date()).format(
        "YYYY-MM-DD HH:mm"
      );
      let selectedMoneyCategory;
      this.$store.state.main.moneyCategories.forEach(row => {
        if (row.code == this.registers[index].moneyCategoryCode) {
          selectedMoneyCategory = row;
        }
      });

      if (!selectedMoneyCategory) {
        console.warn("선택된 통화 카테고리를 찾을 수 없습니다.");
        return; // 에러 방지를 위해 여기서 함수 종료
      }

      if (this.registers[index].moneyCategoryCode == "OTH") {
        selectedMoneyCategory.unit = "";
      }
      this.printDatas[index].foreignCurrency =
        (selectedMoneyCategory?.unit || "") +
        " " +
        this.$h.filterCurrency(this.registers[index].foreignCurrency) +
        ".  X";
      if (this.register.exchangeType == 1) {
        this.printDatas[index].rate = this.registers[index].inRate + ".  =";
      } else {
        this.printDatas[index].rate = this.registers[index].outRate + ".  =";
      }
      this.printDatas[index].result =
        this.$h.filterCurrency(this.registers[index].localOrignCurrency) +
        ".  *";
      this.printData.totalPrice = 0;
      this.registers.forEach(row => {
        // console.log("row : " + row.localCurrency);
        if (
          !this.$h.isEmpty(row.localOrignCurrency) &&
          row.localOrignCurrency != 0
        ) {
          this.printData.totalPrice += row.localOrignCurrency;
        }
      });
      // console.log("totalPrice : ", this.printData.totalPrice);
      // ======================== End ===========================
    },
    getNoType() {
      if (!this.$h.isEmpty(this.register.residenceNo)) {
        return 1;
      } else if (!this.$h.isEmpty(this.register.passportNo)) {
        return 2;
      } else if (!this.$h.isEmpty(this.register.foreignResidenceNo)) {
        return 3;
      } else {
        return 4;
      }
    }
  }
};
</script>
